var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "3600pt",
    height: "3600pt",
    viewBox: "0 0 3600 3600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1487.5 2988c-295.99 1.4258-585.74-85.062-832.52-248.5-246.78-163.44-439.48-396.46-553.68-669.55-114.19-273.08-144.74-573.91-87.766-864.38 56.977-290.46 198.91-557.46 407.8-767.17 208.89-209.7 475.35-352.66 765.59-410.76 290.23-58.098 591.19-28.715 864.71 84.422 273.52 113.14 507.29 304.94 671.68 551.09 164.39 246.15 251.99 535.56 251.71 831.55 0.066407 261.5-68.555 518.42-198.99 745.06-130.43 226.64-318.11 415.04-544.25 546.35-226.13 131.31-482.79 200.93-744.28 201.87zm0-2700c-238.88-1.4258-472.81 68.102-672.13 199.77-199.32 131.67-355.07 319.55-447.49 539.84-92.422 220.28-117.36 463.05-71.66 697.52 45.703 234.47 159.99 450.1 328.38 619.55 168.39 169.45 383.29 285.09 617.47 332.26 234.18 47.176 477.1 23.762 697.96-67.273 220.86-91.039 409.72-245.6 542.64-444.09 132.92-198.49 203.92-431.98 203.99-670.86 0.44531-211.1-54.613-418.6-159.65-601.71-105.04-183.11-256.37-335.39-438.81-441.58-182.45-106.19-389.6-162.55-600.7-163.43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3396.2 3600-995.4-990 203.76-203.76 995.4 989.64z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1cb48510aa698c39729da24b83165866.svg";
export { ForwardRef as ReactComponent };